function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCorrectGenderedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.54 28.54"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M384.87-1916.09a14.26 14.26 0 0 0-14.27 14.27 14.27 14.27 0 0 0 14.27 14.27 14.27 14.27 0 0 0 14.27-14.27 14.27 14.27 0 0 0-14.27-14.27Zm6.25 12-7.21 7.21a1.41 1.41 0 0 1-2 0l-3.32-3.32a1.41 1.41 0 0 1 0-2 1.41 1.41 0 0 1 2 0l2.34 2.34 6.22-6.22a1.39 1.39 0 0 1 2 0 1.41 1.41 0 0 1-.03 1.95Z",
  transform: "translate(-370.6 1916.09)",
  style: {
    fill: "#3f3f3f"
  }
}));

export default SvgCorrectGenderedIcon;